// Painel lateral "Como usar esta tela" (PO1-3506): vídeo já no capítulo da tela,
// passo a passo, manual (visualizador do Hub, PO1-3738), "Ver na Central" e
// "Falar com o suporte". Tela
// com mais de um tutorial (PO1-3738) lista os demais em "Outros vídeos desta
// tela"; clicar troca o vídeo do painel, com o manual e a Central junto. Abre
// por cima da tela (portal em document.body), sem navegar; fecha pelo ×, pelo
// overlay, pelo Esc e ao trocar de rota (quem decide isso é o AjudaTela).
// Sem `?.`/`??`: o build roda em CRA 3.4 / Node 12.
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useHistory } from "react-router-dom";

import { useActiveProduct } from "../../hooks/activeProduct";
import FalarComSuporte from "../../views/Treinamento/FalarComSuporte";
import Player from "../../views/Treinamento/Player";
import { formatarDuracao, rotaCentral } from "../../views/Treinamento/rotas";

// `onFalarComSuporte(contextoInicial)` e `onAbrirManual(tutorial)`: o dono do painel
// abre o chat do suporte e o manual fora do painel (o painel fecha e desmontaria
// os modais junto).
export default function PainelAjuda({ tutorial: principal, inicioSegundos: inicioPrincipal, outros, tela, onFechar, onFalarComSuporte, onAbrirManual }) {
  const history = useHistory();
  const { activeProduct } = useActiveProduct();
  // Código do vídeo escolhido em "Outros vídeos"; null = o principal da tela.
  const [escolhido, setEscolhido] = useState(null);

  useEffect(() => {
    setEscolhido(null);
  }, [principal]);

  const lista = [{ tutorial: principal, inicioSegundos: inicioPrincipal }].concat(Array.isArray(outros) ? outros : []);
  const atual = lista.find((x) => x.tutorial && escolhido && x.tutorial.codigo === escolhido) || lista[0];
  const tutorial = atual.tutorial;
  const inicioSegundos = atual.inicioSegundos;
  const demais = lista.filter((x) => x !== atual && x.tutorial);

  // Trava a rolagem da página por baixo e fecha no Esc.
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const anterior = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") onFechar();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = anterior;
      document.removeEventListener("keydown", onKey);
    };
  }, [onFechar]);

  if (!principal || !tutorial) return null;

  const abrirManual = () => {
    onFechar();
    if (onAbrirManual) onAbrirManual(tutorial);
  };

  const verNaCentral = () => {
    onFechar();
    history.push(rotaCentral(activeProduct, tutorial.codigo));
  };

  const passos = Array.isArray(tutorial.passos) ? tutorial.passos.filter(Boolean) : [];
  const duracao = formatarDuracao(tutorial.duracaoSegundos);

  const painel = (
    <>
      <div className="ajuda-painel__overlay" onClick={onFechar} data-testid="ajuda-painel-overlay" />
      <aside className="ajuda-painel" role="dialog" aria-label="Como usar esta tela" data-testid="ajuda-painel">
        <div className="ajuda-painel__cabecalho">
          <div style={{ minWidth: 0 }}>
            <div className="ajuda-painel__eyebrow">Como usar esta tela</div>
            <div className="ajuda-painel__titulo">
              {tutorial.titulo}
              {duracao ? <span style={{ fontWeight: 500, color: "var(--everlog-card-muted)" }}> · {duracao}</span> : null}
            </div>
          </div>
          <button type="button" className="ajuda-painel__fechar" aria-label="Fechar" onClick={onFechar}>
            ×
          </button>
        </div>

        <div className="ajuda-painel__corpo">
          {tutorial.youtubeId ? (
            <Player
              key={tutorial.codigo}
              youtubeId={tutorial.youtubeId}
              inicioSegundos={inicioSegundos}
              capitulos={tutorial.capitulos}
              titulo={tutorial.titulo}
            />
          ) : null}

          {tutorial.resumo ? (
            <p style={{ margin: 0, fontSize: "0.84rem", lineHeight: 1.5 }}>{tutorial.resumo}</p>
          ) : null}

          {passos.length > 0 ? (
            <div>
              <div className="ajuda-painel__secao-titulo">Passo a passo</div>
              <ol className="ajuda-painel__passos">
                {passos.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ol>
            </div>
          ) : null}

          {demais.length > 0 ? (
            <div data-testid="ajuda-painel-outros">
              <div className="ajuda-painel__secao-titulo">Outros vídeos desta tela</div>
              <ul className="ajuda-painel__outros">
                {demais.map((x) => {
                  const d = formatarDuracao(x.tutorial.duracaoSegundos);
                  return (
                    <li key={x.tutorial.codigo}>
                      <button
                        type="button"
                        className="ajuda-painel__outro"
                        onClick={() => setEscolhido(x === lista[0] ? null : x.tutorial.codigo)}
                        data-testid="ajuda-painel-outro"
                      >
                        <i className="tim-icons icon-triangle-right-17" aria-hidden="true" />
                        <span className="ajuda-painel__outro-titulo">{x.tutorial.titulo}</span>
                        {d ? <span className="ajuda-painel__outro-duracao">{d}</span> : null}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : null}
        </div>

        <div className="ajuda-painel__rodape">
          {tutorial.temManual ? (
            <button type="button" className="ajuda-painel__botao-largo" onClick={abrirManual}>
              Manual
            </button>
          ) : null}
          <button type="button" className="ajuda-painel__botao-largo" onClick={verNaCentral}>
            Ver na Central de Treinamento
          </button>
          <FalarComSuporte tela={tela} onAbrir={onFechar} onSolicitar={onFalarComSuporte} block size="sm" compacto />
        </div>
      </aside>
    </>
  );

  return typeof document !== "undefined" ? ReactDOM.createPortal(painel, document.body) : painel;
}
